
define('text!setup/header/header.html',[],function () { return '<div class="header container">\n    <div class="{{welcomeClass}}">{{welcomeText}}</div>\n    <div data-bind="visible: !isFreeTrialUser && !isG2MMSchedulingTest" class="step-description">{{stepDescription}}</div>\n</div>\n';});

